import axios from "axios";
import {useRef, useEffect, useState} from "react";
import {toast} from "react-toastify";
import Loader from "../Loader";
import "./Login.scss";
import {Link} from "react-router-dom";

export default function Login({isAuthenticated}) {
    const [isAuth, setIsAuth] = isAuthenticated;
    const [errorMessage, setErrorMessage] = useState("");
    const [items, setItems] = useState();

    const [isAutoLogin, setIsAutoLogin] = useState(
        localStorage.getItem("token") === null ? false : true
    );

    let HOST = localStorage.getItem("apiUrl");


    useEffect(() => {
        if (isAutoLogin) {
            axios({
                method: "POST",
                url: `${HOST}/check_user/`,
                params: {token: ""},
                headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
            })
                .then((response) => {
                    for (const key in response.data) {
                        localStorage.setItem(key, response.data[key]);
                    }
                    setIsAuth(true);
                    console.log("auto login succuss!!");
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(`error: ${error.message}`);
                        console.log(`response: ${error.response.data}`);
                        localStorage.removeItem("token");
                        setIsAutoLogin(false);
                    }
                });
        } else {
            axios({url: `${HOST}/check_user/`, params: {list: ""}}).then(
                (response) => {
                    setItems(response.data);
                }
            );
        }
    }, [isAutoLogin, HOST]);
    // captcha
    let alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
    const generate = () => {
        let first = alphabets[Math.floor(Math.random() * alphabets.length)];
        let second = Math.floor(Math.random() * 10);
        let third = Math.floor(Math.random() * 10);
        let fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
        let fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
        let sixth = Math.floor(Math.random() * 10);
        let captcha =
            first.toString() +
            second.toString() +
            third.toString() +
            fourth.toString() +
            fifth.toString() +
            sixth.toString();
        return captcha;
    };
    const check = (value) => {
        if (value.toLowerCase() === chaptchaCode.toLowerCase()) {
            return true;
        } else {
            return false;
        }
    };
    const [chaptchaCode, setChaptchaCode] = useState(generate());
    const giveMeNewCaptchaCode = () => {
        setChaptchaCode(generate());
    };

    // End Of Captcha
    function handleSubmit(e) {
        setErrorMessage("");
        e.preventDefault();
        let form = e.target;
        // check captcha Code
        if (!check(form.elements["entered-captcha"].value)) {
            setErrorMessage("در وارد کردن کپچا دقت کنید.");
            return;
        }
        axios({
            method: "POST",
            url: `${HOST}/check_user/`,
            params: {
                user: form.elements["username"].value,
                pass: form.elements["password"].value,
            },
        })
            .then((response) => {
              if(response.data){
                for (const key in response.data) {
                  localStorage.setItem(key, response.data[key]);
                }
                setIsAuth(true);
                setErrorMessage("");
              }else if(response.toJSON().status===401){
                setErrorMessage("نام کاربری یا رمز عبور نادرست است");
              }

            })
            .catch((error) => {
                debugger
                error.response.status === 401 &&
                setErrorMessage("نام کاربری یا رمز عبور نادرست است");
            });
    }

    let forgetPasswordForm = (
        <form>
            <div className="row">
                <i className="fas fa-phone"></i>
                <input
                    type="text"
                    id="phoneNumber"
                    placeholder="شماره تلفن همراه خود را وارد کنید"
                    required
                />
            </div>

            <div className="row button mt-5">
                <input type="submit" id="sendCode" value="ارسال"/>
            </div>
            <small className="response-msg"></small>
            <div>
                <a className="return-login">بازگشت به صفحه ورود</a>
            </div>
        </form>
    );

    const datalist = useRef(null);
    const passWord = useRef(null);
    const userNameRef = useRef(null);
    // const [focused, setFocused] = useState(false);
    const [focusedUserName, setFocusedUserName] = useState(false);

    useEffect(() => {
        focusedUserName ? datalist.current.style.display = "block" : datalist.current.style.display = "none";
    }, [focusedUserName]);


    // const [wannachangeInputPlease, setWannachangeInputPlease] = useState(false);

    // useEffect(() => {
    //   // focusedUserName ? datalist.current.style.display = "block" : datalist.current.style.display = "none";
    //   // userName.current.value = newValue
    //   console.log("wannachangeInputPlease");
    // }, [wannachangeInputPlease]);


    // useEffect(() => {
    //   if (passWord.current !== null) {
    //     passWord.current.removeAttribute("readOnly");
    //   }
    // }, [focused]);

    // useEffect(() => {
    //   if (userName.current !== null) {
    //     userName.current.removeAttribute("readOnly");
    //   }
    // }, [focusedUserName]);

    const onClickToSelectUserToPutIn = (item) => {
        userNameRef.current.value = item;
        setFocusedUserName(false);
    }

    return (
        <div className="login-page py-4 mt-1  mb-5">
            {isAutoLogin && (
                <div className="auto-login-frame">
                    <Loader text="در حال ورود به سیستم"/>
                </div>
            )}
            <div className="container">
                <div className="wrapper login-section ">
                    <div className="title">
                        <span>ورود کاربر</span>
                    </div>
                    <form onSubmit={handleSubmit} autoComplete="off">

                        <div className="row">
                            <i className="fas fa-user"></i>
                            {/* <input autoComplete="false" name="hidden" type="text" style={{'display':'none'}}/> */}
                            <input ref={userNameRef}
                                   type={"text"}
                                   onFocus={() => setFocusedUserName(true)}
                                // onBlur={() => setFocusedUserName(false)}
                                   focusOut={() => setFocusedUserName(false)}
                                   name="username"
                                   list="usersList"
                                   placeholder={
                                       items === undefined
                                           ? "درحال بارگذاری"
                                           : "مشخصه کاربر را انتخاب کنید"
                                   }
                                   aria-autocomplete="both"
                                   aria-haspopup="false"
                                   autoCapitalize="off"
                                   autoComplete="off"
                                   autoCorrect="off"
                                   autoFocus=""
                                   role="combobox"
                                   spellCheck="false"
                                   novalidate
                            />
                            <div ref={datalist} id="usersList" className={"datalistnew"}>
                                <div>
                                    {items !== undefined &&
                                        items.map((item, index) => (
                                            <span key={index} onClick={() => onClickToSelectUserToPutIn(item)}
                                                  type="button" className="">
                        {item}
                      </span>
                                        ))}
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <i className="fas fa-lock"></i>
                            <input ref={passWord}
                                   type="password"
                                   name="password"
                                   placeholder="رمز عبور"
                                   required
                                   aria-autocomplete="both" aria-haspopup="false" autoCapitalize="off"
                                   autoComplete="off" autoCorrect="off" autoFocus="" role="combobox" spellCheck="false"

                            />
                        </div>
                        <div className="row">
                            <i className="fa" onClick={giveMeNewCaptchaCode}>
                                &#xf021;
                            </i>
                            <div
                                className=" disable-selection font-for-capcha input-style"
                                id="generated-captcha"
                            >
                                {chaptchaCode}
                            </div>
                        </div>
                        <div className="row">
                            <i className="fas fa-lock"></i>
                            <input
                                className="entered-captcha"
                                type="text"
                                name="entered-captcha"
                                placeholder="کد بالا را وارد کنید"
                                required
                                aria-autocomplete="both" aria-haspopup="false" autoCapitalize="off" autoComplete="off"
                                autoCorrect="off" autoFocus="" role="combobox" spellCheck="false"

                            />
                        </div>
                        <p className="error-field">{errorMessage}</p>
                        <div className="row button mt-4">
                            <input type="submit" value="ورود"/>
                        </div>
                    </form>
                    <div className="pass">
                        <span><Link to={"/ForgetPassword"}>فراموشی کلمه عبور</Link></span>
                    </div>
                </div>
                {/*<div className="wrapper forgot-section">*/}
                {/*    <div className="title">*/}
                {/*        <span><Link to={"forgetPassword"}>فراموشی کلمه عبور</Link></span>*/}

                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}
